import AuthButton from "components/user/AuthButton";
import AuthButtonMobile from "components/user/AuthButtonMobile";
import { get } from "lodash";
import CartButton from "components/cart/CartButton";
import WishlistButton from "components/header/WishlistButton";
import { CloseOutlined } from "@ant-design/icons";
import { useState } from "react";

import Link from "next/link";
import Image from "grandus-lib/components-atomic/image/Image";
import HeaderMenu from "./Menu.js";

import startsWith from "lodash/startsWith";

import styles from "./Header.module.scss";
import Transition from "pages/_transition";
import { useRouter } from "next/router";
import LanguageSwitch from "./LanguageSwitch";
import useWebInstance from "grandus-lib/hooks/useWebInstance";

const Header = ({isSrandon}) => {
  const router = useRouter();
  const data = useWebInstance()

  const [openedMenu, setOpenedMenu] = useState(false);

  const webinstance = get(data, "webInstance", {});
  const logoPath =
    get(webinstance, "logo.path") + "/" + get(webinstance, "logo.id");
  const logo = {
    ...get(webinstance, "logo", {}),
    path: logoPath,
  };
  return (
    <header id={styles.header} className={isSrandon ? styles.srandonHeader : ""}>
      <div className="container">
        <div className={styles.topBar}>
          <div className={styles.logoWrapper}>
            <Link href="/" as={`/`}>
              <a>
                <Image
                  photo={logo}
                  size={"106x41"}
                  type={"png"}
                  className="logo"
                  imageProps={{
                    width: 106,
                    height: 41,
                  }}
                />
              </a>
            </Link>
          </div>
          <Transition>
            <div
              className={`${styles.menuWrapper} ${
                openedMenu ? styles.open : ""
              }`}
            >
              <Link href="/" as={`/`}>
                <a>
                  <Image
                    photo={logo}
                    size={"106x41"}
                    type={"png"}
                    className={styles.logo}
                    imageProps={{
                      width: 106,
                      height: 41,
                    }}
                  />
                </a>
              </Link>
              <a
                className={styles.closeButton}
                onClick={() => setOpenedMenu(!openedMenu)}
              >
                <CloseOutlined style={{ fontSize: "1.5em" }} />
              </a>
              <ul className={styles.menu}>
                <HeaderMenu />
                {get(webinstance, "pagesHeader", []).map((page, index) => {
                  return (
                    <li key={`top-bar-static-page-${page.id}-${index}`}>
                      {get(page, "externalUrl") ? (
                        <a
                          href={get(page, "externalUrl")}
                          className={styles?.firstLevel}
                        >
                          {page.title}
                        </a>
                      ) : (
                        <Link
                          href="/stranka/[id]"
                          as={`/stranka/${page.urlTitle}`}
                        >
                          <a
                            onClick={() => setOpenedMenu(false)}
                            className={styles?.firstLevel}
                          >
                            {page.title}
                          </a>
                        </Link>
                      )}
                    </li>
                  );
                })}
                <LanguageSwitch />
              </ul>
            </div>
          </Transition>
          <div className={styles.iconsWrapper}>
            <a
              className={styles.mobileMenu}
              onClick={() => setOpenedMenu(!openedMenu)}
            >
              {openedMenu ? (
                <CloseOutlined style={{ fontSize: "2.3em" }} />
              ) : (
                <svg
                  width="29"
                  height="23"
                  viewBox="0 0 29 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0)">
                    <path
                      d="M1.48718 1.48386H27.5128"
                      stroke="black"
                      strokeWidth="3"
                      strokeMiterlimit="10"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M1.48718 21.2045H10.1649"
                      stroke="black"
                      strokeWidth="3"
                      strokeMiterlimit="10"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M1.48718 11.3442H18.8351"
                      stroke="black"
                      strokeWidth="3"
                      strokeMiterlimit="10"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0">
                      <rect width="29" height="22.6884" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              )}
            </a>
            <div className={styles?.actionButtons}>
              <AuthButtonMobile />
              <WishlistButton />
              <CartButton />
            </div>
            <div className={styles?.authButton}>
              <AuthButton />
            </div>
          </div>
        </div>
      </div>

      {/* <div className={styles.separator} />` */}
    </header>
  );
};

export default Header;
